import cn from 'classnames'
import * as React from 'react'
import styles from './FooterContainer.module.css'

type FooterContainerProps = { transparentBackground?: boolean } & React.ComponentPropsWithoutRef<'footer'>

function FooterContainer({
  children,
  transparentBackground,
  className,
  ...attrs
}: React.PropsWithChildren<FooterContainerProps>) {
  return (
    <footer
      id="footer"
      className={cn(
        styles.footer,
        transparentBackground && styles.transparent,
        className,
      )}
      {...attrs}
    >
      <div className={styles.footerLayout}>
        <div className={styles.footerBody}>
          {children}
        </div>
      </div>
    </footer>
  )
}

export default FooterContainer
